/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1ApiKeysDeleteKeyRequestBody = {
  /**
   * API key identifier returned by apiKeys.createKey or apiKeys.listKeys.
   */
  keyId: string;
};

/** @internal */
export type V1ApiKeysDeleteKeyRequestBody$Outbound = {
  keyId: string;
};

/** @internal */
export const V1ApiKeysDeleteKeyRequestBody$outboundSchema: z.ZodType<
  V1ApiKeysDeleteKeyRequestBody$Outbound,
  z.ZodTypeDef,
  V1ApiKeysDeleteKeyRequestBody
> = z.object({
  keyId: z.string(),
});

export function v1ApiKeysDeleteKeyRequestBodyToJSON(
  v1ApiKeysDeleteKeyRequestBody: V1ApiKeysDeleteKeyRequestBody,
): string {
  return JSON.stringify(
    V1ApiKeysDeleteKeyRequestBody$outboundSchema.parse(
      v1ApiKeysDeleteKeyRequestBody,
    ),
  );
}
